import { Helmet } from "react-helmet-async";

const SITE_URL = "https://bancony.com";
// TODO: replace with a proper branded OG card (1200x630) once design provides one.
const DEFAULT_OG = "/img/og-default.png";

export const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_OG,
  noindex = false,
}) => {
  const fullTitle = title ? `${title} | Bancony` : "Bancony | AI for Banking";
  const url = `${SITE_URL}${path}`;
  const imageUrl = image.startsWith("http") ? image : `${SITE_URL}${image}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description ? <meta name="description" content={description} /> : null}
      <link rel="canonical" href={url} />
      {noindex ? <meta name="robots" content="noindex" /> : null}

      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content="Bancony" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description ? <meta name="twitter:description" content={description} /> : null}
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
};
